export const clearPathwayIds = (items, pathwayId) => {
    return items.map(item => {
        item.pathwayIds = item.pathwayIds.filter(id => id !== pathwayId);
        return item;
    });
};
//# sourceMappingURL=utils.js.map